//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/common";
import * as OM from "@/Model";
import { baseUrl } from '@/config';

class _BackendNotificationClient {

        
    countNew(
        until:string,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'BackendNotification/CountNew',{ until  }, showSpinner);

            }
        
        
    getMine(
        page:number,
        until:string,showSpinner = true): Promise<OM.BackendNotification[]> {
                return CommonServices.get<OM.BackendNotification[]>(baseUrl + 'BackendNotification/GetMine',{ page , until  }, showSpinner);

            }
        
        
    setReadUntil(
        fromTime:string,
        toTime:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BackendNotification/SetReadUntil',{ fromTime , toTime  }, showSpinner);

            }
        
        
    remove(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BackendNotification/Remove',{ identifier  }, showSpinner);

            }
                }

export let BackendNotificationClient = new _BackendNotificationClient();

class _ContrattoCollaborazioneClient {

        
    getAll(showSpinner = true): Promise<OM.ContrattoCollaborazione[]> {
                return CommonServices.get<OM.ContrattoCollaborazione[]>(baseUrl + 'ContrattoCollaborazione/GetAll',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.ContrattoCollaborazione> {
                return CommonServices.get<OM.ContrattoCollaborazione>(baseUrl + 'ContrattoCollaborazione/GetById',{ identifier  }, showSpinner);

            }
        
        
    generateContract(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ContrattoCollaborazione/GenerateContract',{ userIdentifier  }, showSpinner);

            }
        
        
    approvaContratto(
        contractIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ContrattoCollaborazione/ApprovaContratto',{ contractIdentifier  }, showSpinner);

            }
        
        
    respingiContratto(
        vm:OM.TextIdentifier,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'ContrattoCollaborazione/RespingiContratto', vm ,{}, showSpinner );

            }
        
        
    checkContratto(
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'ContrattoCollaborazione/CheckContratto',{ userIdentifier  }, showSpinner);

            }
        
        
    getDataFirmaContratto(
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'ContrattoCollaborazione/GetDataFirmaContratto',{ userIdentifier  }, showSpinner);

            }
        
        
    getRejectionReason(
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'ContrattoCollaborazione/GetRejectionReason',{ userIdentifier  }, showSpinner);

            }
        
        
    getComments(
        userIdentifier:string,showSpinner = true): Promise<OM.Comment[]> {
                return CommonServices.get<OM.Comment[]>(baseUrl + 'ContrattoCollaborazione/GetComments',{ userIdentifier  }, showSpinner);

            }
        
        
    getAllegati(
        userIdentifier:string,showSpinner = true): Promise<OM.Comment[]> {
                return CommonServices.get<OM.Comment[]>(baseUrl + 'ContrattoCollaborazione/GetAllegati',{ userIdentifier  }, showSpinner);

            }
        
        
    getSignedDocuments(
        userIdentifier:string,showSpinner = true): Promise<OM.Attachment[]> {
                return CommonServices.get<OM.Attachment[]>(baseUrl + 'ContrattoCollaborazione/GetSignedDocuments',{ userIdentifier  }, showSpinner);

            }
        
        
    signContract(
        userIdentifier:string,
        otp:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ContrattoCollaborazione/SignContract',{ userIdentifier , otp  }, showSpinner);

            }
                }

export let ContrattoCollaborazioneClient = new _ContrattoCollaborazioneClient();

class _DocumentoDashboardClient {

        
    getByFolder(
        folder:string,showSpinner = true): Promise<OM.DocumentoDashboard[]> {
                return CommonServices.get<OM.DocumentoDashboard[]>(baseUrl + 'DocumentoDashboard/GetByFolder',{ folder  }, showSpinner);

            }
        
        
    getFolders(showSpinner = true): Promise<OM.GetFoldersResponseVm[]> {
                return CommonServices.get<OM.GetFoldersResponseVm[]>(baseUrl + 'DocumentoDashboard/GetFolders',{  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.DocumentoDashboard[]> {
                return CommonServices.get<OM.DocumentoDashboard[]>(baseUrl + 'DocumentoDashboard/GetAll',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.DocumentoDashboard> {
                return CommonServices.get<OM.DocumentoDashboard>(baseUrl + 'DocumentoDashboard/GetById',{ identifier  }, showSpinner);

            }
        
        
    save(
        item:OM.DocumentoDashboard,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'DocumentoDashboard/Save', item ,{}, showSpinner );

            }
        
        
    addUserRead(
        docIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'DocumentoDashboard/AddUserRead',{ docIdentifier , userIdentifier  }, showSpinner);

            }
        
        
    delete(
        docIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'DocumentoDashboard/Delete',{ docIdentifier  }, showSpinner);

            }
                }

export let DocumentoDashboardClient = new _DocumentoDashboardClient();

class _EsclusioneOrariPrenotazioneClient {

        
    save(
        items:OM.EsclusioneOrariPrenotazione[],showSpinner = true): Promise<string[]> {
                return CommonServices.post<string[]>(baseUrl + 'api/EsclusioneOrariPrenotazione/Save', items ,{}, showSpinner );

            }
        
        
    getByDate(
        consulenteIdentifier:string,
        date:string,showSpinner = true): Promise<OM.EsclusioneOrariPrenotazione[]> {
                return CommonServices.get<OM.EsclusioneOrariPrenotazione[]>(baseUrl + 'api/EsclusioneOrariPrenotazione/GetByDate',{ consulenteIdentifier , date  }, showSpinner);

            }
        
        
    getByConsulente(
        consulenteIdentifier:string,showSpinner = true): Promise<OM.EsclusioneOrariPrenotazione[]> {
                return CommonServices.get<OM.EsclusioneOrariPrenotazione[]>(baseUrl + 'api/EsclusioneOrariPrenotazione/GetByConsulente',{ consulenteIdentifier  }, showSpinner);

            }
        
        
    deleteById(
        esclusioneIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/EsclusioneOrariPrenotazione/DeleteById',{ esclusioneIdentifier  }, showSpinner);

            }
                }

export let EsclusioneOrariPrenotazioneClient = new _EsclusioneOrariPrenotazioneClient();

class _FaqNodeClient {

        
    getById(
        faqNodeIdentifier:string,showSpinner = true): Promise<OM.FaqNode> {
                return CommonServices.get<OM.FaqNode>(baseUrl + 'FaqNode/GetById',{ faqNodeIdentifier  }, showSpinner);

            }
        
        
    save(
        item:OM.FaqNode,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'FaqNode/Save', item ,{}, showSpinner );

            }
        
        
    addAnswerToNode(
        nodeIdentifier:string,showSpinner = true): Promise<OM.TextIdentifier> {
                return CommonServices.get<OM.TextIdentifier>(baseUrl + 'FaqNode/AddAnswerToNode',{ nodeIdentifier  }, showSpinner);

            }
        
        
    removeAnswerToNode(
        nodeIdentifier:string,
        answerIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'FaqNode/RemoveAnswerToNode',{ nodeIdentifier , answerIdentifier  }, showSpinner);

            }
        
        
    getRoot(showSpinner = true): Promise<OM.FaqNode> {
                return CommonServices.get<OM.FaqNode>(baseUrl + 'FaqNode/GetRoot',{  }, showSpinner);

            }
                }

export let FaqNodeClient = new _FaqNodeClient();

class _InclusioneOrariPrenotazioneClient {

        
    save(
        items:OM.InclusioneOrariPrenotazione[],showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/InclusioneOrariPrenotazione/Save', items ,{}, showSpinner );

            }
        
        
    getByConsulente(
        consulenteIdentifier:string,showSpinner = true): Promise<OM.InclusioneOrariPrenotazione[]> {
                return CommonServices.get<OM.InclusioneOrariPrenotazione[]>(baseUrl + 'api/InclusioneOrariPrenotazione/GetByConsulente',{ consulenteIdentifier  }, showSpinner);

            }
        
        
    deleteById(
        esclusioneIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'api/InclusioneOrariPrenotazione/DeleteById',{ esclusioneIdentifier  }, showSpinner);

            }
                }

export let InclusioneOrariPrenotazioneClient = new _InclusioneOrariPrenotazioneClient();

class _LocalizedClient {

        
    saveLocalizedValue(
        item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Localized/SaveLocalizedValue', item ,{}, showSpinner );

            }
        
        
    saveAnonymousLocalizedValue(
        item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Localized/SaveAnonymousLocalizedValue', item ,{}, showSpinner );

            }
        
        
    saveLocalizedEntity(
        item:OM.LocalizedEntity,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'api/Localized/SaveLocalizedEntity', item ,{}, showSpinner );

            }
        
        
    getAppDictionary(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                return CommonServices.get<OM.LocalizedEntity[]>(baseUrl + 'api/Localized/GetAppDictionary',{  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                return CommonServices.get<OM.LocalizedEntity[]>(baseUrl + 'api/Localized/GetAll',{  }, showSpinner);

            }
        
        
    getEnabledLanguages(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/Localized/GetEnabledLanguages',{  }, showSpinner);

            }
        
        
    getSupportedLanguages(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/Localized/GetSupportedLanguages',{  }, showSpinner);

            }
        
        
    editLocalizedValue(
        value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Localized/EditLocalizedValue', value ,{}, showSpinner );

            }
                }

export let LocalizedClient = new _LocalizedClient();

class _LoginClient {

        
    login(
        vm:OM.LoginVm,showSpinner = true): Promise<OM.LoginData> {
                return CommonServices.post<OM.LoginData>(baseUrl + 'Login/Login', vm ,{}, showSpinner );

            }
        
        
    loginWithTempPassword(
        vm:OM.LoginVm,showSpinner = true): Promise<OM.LoginData> {
                return CommonServices.post<OM.LoginData>(baseUrl + 'Login/LoginWithTempPassword', vm ,{}, showSpinner );

            }
        
        
    switchToAccount(
        userIdentifier:string,showSpinner = true): Promise<OM.LoginData> {
                return CommonServices.get<OM.LoginData>(baseUrl + 'Login/SwitchToAccount',{ userIdentifier  }, showSpinner);

            }
        
        
    checkEmailAvailable(
        email:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'Login/CheckEmailAvailable',{ email  }, showSpinner);

            }
        
        
    register(
        vm:OM.RegisterVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Login/Register', vm ,{}, showSpinner );

            }
        
        
    registerFromCentro(
        vm:OM.RegisterVm,showSpinner = true): Promise<OM.Cliente> {
                return CommonServices.post<OM.Cliente>(baseUrl + 'Login/RegisterFromCentro', vm ,{}, showSpinner );

            }
        
        
    sendTempPassword(
        username:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Login/SendTempPassword',{ username  }, showSpinner);

            }
        
        
    sendSmsPassword(
        username:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Login/SendSmsPassword',{ username  }, showSpinner);

            }
        
        
    setNewPassword(
        password:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Login/SetNewPassword',{ password  }, showSpinner);

            }
        
        
    refreshLogin(showSpinner = true): Promise<OM.LoginData> {
                return CommonServices.get<OM.LoginData>(baseUrl + 'Login/RefreshLogin',{  }, showSpinner);

            }
                }

export let LoginClient = new _LoginClient();

class _MailSentLogClient {

        
    getAllPaginated(
        vm:OM.MailSentLogListFilterVm,showSpinner = true): Promise<OM.PagedResultOfMailSentLog> {
                return CommonServices.post<OM.PagedResultOfMailSentLog>(baseUrl + 'MailSentLog/GetAllPaginated', vm ,{}, showSpinner );

            }
                }

export let MailSentLogClient = new _MailSentLogClient();

class _MessageOfTheDayClient {

        
    getAll(showSpinner = true): Promise<OM.MessageOfTheDay[]> {
                return CommonServices.get<OM.MessageOfTheDay[]>(baseUrl + 'MessageOfTheDay/GetAll',{  }, showSpinner);

            }
        
        
    getMessageOfTheDay(showSpinner = true): Promise<OM.MessageOfTheDay> {
                return CommonServices.get<OM.MessageOfTheDay>(baseUrl + 'MessageOfTheDay/GetMessageOfTheDay',{  }, showSpinner);

            }
        
        
    save(
        item:OM.MessageOfTheDay,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'MessageOfTheDay/Save', item ,{}, showSpinner );

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'MessageOfTheDay/Delete',{ identifier  }, showSpinner);

            }
                }

export let MessageOfTheDayClient = new _MessageOfTheDayClient();

class _NazioneClient {

        
    getAll(showSpinner = true): Promise<OM.Nazione[]> {
                return CommonServices.get<OM.Nazione[]>(baseUrl + 'Nazione/GetAll',{  }, showSpinner);

            }
        
        
    getEnabled(showSpinner = true): Promise<OM.Nazione[]> {
                return CommonServices.get<OM.Nazione[]>(baseUrl + 'Nazione/GetEnabled',{  }, showSpinner);

            }
        
        
    getPrefissiTelefonici(showSpinner = true): Promise<OM.NumberNazione[]> {
                return CommonServices.get<OM.NumberNazione[]>(baseUrl + 'Nazione/GetPrefissiTelefonici',{  }, showSpinner);

            }
        
        
    getNazioni(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'Nazione/GetNazioni',{  }, showSpinner);

            }
        
        
    save(
        item:OM.Nazione,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Nazione/save', item ,{}, showSpinner );

            }
                }

export let NazioneClient = new _NazioneClient();

class _PagamentoBonificoClient {

        
    getAll(showSpinner = true): Promise<OM.PagamentoBonifico[]> {
                return CommonServices.get<OM.PagamentoBonifico[]>(baseUrl + 'PagamentoBonifico/GetAll',{  }, showSpinner);

            }
        
        
    getByFilterVm(
        vm:OM.PagamentoBonificoListFilterVm,showSpinner = true): Promise<OM.PagedResultOfPagamentoBonifico> {
                return CommonServices.post<OM.PagedResultOfPagamentoBonifico>(baseUrl + 'PagamentoBonifico/GetByFilterVm', vm ,{}, showSpinner );

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.PagamentoBonifico> {
                return CommonServices.get<OM.PagamentoBonifico>(baseUrl + 'PagamentoBonifico/GetById',{ identifier  }, showSpinner);

            }
        
        
    getByAcquistoClienteIdentifier(
        acquistoClienteIdentifier:string,showSpinner = true): Promise<OM.PagamentoBonifico> {
                return CommonServices.get<OM.PagamentoBonifico>(baseUrl + 'PagamentoBonifico/GetByAcquistoClienteIdentifier',{ acquistoClienteIdentifier  }, showSpinner);

            }
        
        
    save(
        pagamento:OM.PagamentoBonifico,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'PagamentoBonifico/Save', pagamento ,{}, showSpinner );

            }
        
        
    confermaPagamento(
        identifier:string,
        pagamentoType:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'PagamentoBonifico/ConfermaPagamento',{ identifier , pagamentoType  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'PagamentoBonifico/Delete',{ identifier  }, showSpinner);

            }
        
        
    annullaPagamentoBonifico(
        acquistoClienteIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'PagamentoBonifico/AnnullaPagamentoBonifico',{ acquistoClienteIdentifier  }, showSpinner);

            }
        
        
    removeCommento(
        itemIdentifier:string,
        commentIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'PagamentoBonifico/RemoveCommento',{ itemIdentifier , commentIdentifier  }, showSpinner);

            }
                }

export let PagamentoBonificoClient = new _PagamentoBonificoClient();

class _AcquistoClienteClient {

        
    deleteById(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'AcquistoCliente/DeleteById',{ identifier  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.AcquistoClienteListVm[]> {
                return CommonServices.get<OM.AcquistoClienteListVm[]>(baseUrl + 'AcquistoCliente/GetAll',{  }, showSpinner);

            }
        
        
    getAllByFilter(
        vm:OM.AcquistoClienteListFilterVm,showSpinner = true): Promise<OM.PagedResultOfAcquistoClienteListVm> {
                return CommonServices.post<OM.PagedResultOfAcquistoClienteListVm>(baseUrl + 'AcquistoCliente/GetAllByFilter', vm ,{}, showSpinner );

            }
        
        
    getByUser(
        clienteIdentifier:string,showSpinner = true): Promise<OM.AcquistoClienteVm[]> {
                return CommonServices.get<OM.AcquistoClienteVm[]>(baseUrl + 'AcquistoCliente/GetByUser',{ clienteIdentifier  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.AcquistoCliente> {
                return CommonServices.get<OM.AcquistoCliente>(baseUrl + 'AcquistoCliente/GetById',{ identifier  }, showSpinner);

            }
        
        
    setLavorato(
        identifier:string,
        lavorato:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'AcquistoCliente/SetLavorato',{ identifier , lavorato  }, showSpinner);

            }
        
        
    save(
        item:OM.AcquistoCliente,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'AcquistoCliente/Save', item ,{}, showSpinner );

            }
        
        
    getAcquistiInAttesa(
        clienteIdentifier:string,showSpinner = true): Promise<OM.AcquistoClienteVmWithOffers[]> {
                return CommonServices.get<OM.AcquistoClienteVmWithOffers[]>(baseUrl + 'AcquistoCliente/GetAcquistiInAttesa',{ clienteIdentifier  }, showSpinner);

            }
        
        
    sendInformazioniBonifico(
        acquistoClienteIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'AcquistoCliente/SendInformazioniBonifico',{ acquistoClienteIdentifier  }, showSpinner);

            }
                }

export let AcquistoClienteClient = new _AcquistoClienteClient();

class _BaseProductClient {

        
    getAll(showSpinner = true): Promise<OM.BaseProductVm[]> {
                return CommonServices.get<OM.BaseProductVm[]>(baseUrl + 'BaseProduct/GetAll',{  }, showSpinner);

            }
        
        
    getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'BaseProduct/GetAllNameIdentifier',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                return CommonServices.get<OM.BaseProduct>(baseUrl + 'BaseProduct/GetById',{ identifier  }, showSpinner);

            }
        
        
    duplicaProdotto(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BaseProduct/DuplicaProdotto',{ identifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BaseProduct/Delete',{ identifier  }, showSpinner);

            }
                }

export let BaseProductClient = new _BaseProductClient();

class _OffertaClient {

        
    getAll(showSpinner = true): Promise<OM.OffertaForListVm[]> {
                return CommonServices.get<OM.OffertaForListVm[]>(baseUrl + 'Offerta/GetAll',{  }, showSpinner);

            }
        
        
    checkContainsSpedibili(
        offerIdentifier:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'Offerta/CheckContainsSpedibili',{ offerIdentifier  }, showSpinner);

            }
        
        
    checkContainsCorso(
        offerIdentifier:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'Offerta/CheckContainsCorso',{ offerIdentifier  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Offerta> {
                return CommonServices.get<OM.Offerta>(baseUrl + 'Offerta/GetById',{ identifier  }, showSpinner);

            }
        
        
    getByCategory(
        shopCategoryIdentifier:string,showSpinner = true): Promise<OM.Offerta[]> {
                return CommonServices.get<OM.Offerta[]>(baseUrl + 'Offerta/GetByCategory',{ shopCategoryIdentifier  }, showSpinner);

            }
        
        
    getByCategoryType(
        type:string,showSpinner = true): Promise<OM.Offerta[]> {
                return CommonServices.get<OM.Offerta[]>(baseUrl + 'Offerta/GetByCategoryType',{ type  }, showSpinner);

            }
        
        
    save(
        item:OM.Offerta,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Offerta/Save', item ,{}, showSpinner );

            }
        
        
    completeBuyOfferta(
        vm:OM.BuyCartRequestVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Offerta/CompleteBuyOfferta', vm ,{}, showSpinner );

            }
        
        
    getAllAsNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Offerta/GetAllAsNameIdentifier',{  }, showSpinner);

            }
        
        
    buyOffertaBonifico(
        vm:OM.BuyCartRequestVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Offerta/BuyOffertaBonifico', vm ,{}, showSpinner );

            }
        
        
    disable(
        identifier:string,
        disable:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Offerta/Disable',{ identifier , disable  }, showSpinner);

            }
        
        
    getOffersForCliente(
        clienteIdentifier:string,
        categoryIdentifier:string,showSpinner = true): Promise<OM.OfferWithBoughtVm[]> {
                return CommonServices.get<OM.OfferWithBoughtVm[]>(baseUrl + 'Offerta/GetOffersForCliente',{ clienteIdentifier , categoryIdentifier  }, showSpinner);

            }
        
        
    getByCategoryTypeAndClienteLevel(
        clienteIdentifier:string,
        categoryType:string,showSpinner = true): Promise<OM.Offerta[]> {
                return CommonServices.get<OM.Offerta[]>(baseUrl + 'Offerta/GetByCategoryTypeAndClienteLevel',{ clienteIdentifier , categoryType  }, showSpinner);

            }
        
        
    duplicaOfferta(
        offertaIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Offerta/DuplicaOfferta',{ offertaIdentifier  }, showSpinner);

            }
        
        
    deleteById(
        offertaIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Offerta/DeleteById',{ offertaIdentifier  }, showSpinner);

            }
        
        
    getAllUpsellOffers(showSpinner = true): Promise<OM.Offerta[]> {
                return CommonServices.get<OM.Offerta[]>(baseUrl + 'Offerta/GetAllUpsellOffers',{  }, showSpinner);

            }
        
        
    getUpsellOffers(
        parentOfferIdentifier:string,showSpinner = true): Promise<OM.OfferWithBoughtVm[]> {
                return CommonServices.get<OM.OfferWithBoughtVm[]>(baseUrl + 'Offerta/GetUpsellOffers',{ parentOfferIdentifier  }, showSpinner);

            }
                }

export let OffertaClient = new _OffertaClient();

class _ProductAppuntamentoClient {

        
    save(
        item:OM.ProductAppuntamento,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'ProductAppuntamento/Save', item ,{}, showSpinner );

            }
        
        
    getAll(showSpinner = true): Promise<OM.BaseProductVm[]> {
                return CommonServices.get<OM.BaseProductVm[]>(baseUrl + 'ProductAppuntamento/GetAll',{  }, showSpinner);

            }
        
        
    getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'ProductAppuntamento/GetAllNameIdentifier',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                return CommonServices.get<OM.BaseProduct>(baseUrl + 'ProductAppuntamento/GetById',{ identifier  }, showSpinner);

            }
        
        
    duplicaProdotto(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ProductAppuntamento/DuplicaProdotto',{ identifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ProductAppuntamento/Delete',{ identifier  }, showSpinner);

            }
                }

export let ProductAppuntamentoClient = new _ProductAppuntamentoClient();

class _ProductCourseClient {

        
    save(
        item:OM.ProductCourse,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'ProductCourse/Save', item ,{}, showSpinner );

            }
        
        
    getCourse(
        identifier:string,showSpinner = true): Promise<OM.ProductCourse> {
                return CommonServices.get<OM.ProductCourse>(baseUrl + 'ProductCourse/GetCourse',{ identifier  }, showSpinner);

            }
        
        
    getClienteCourses(
        clienteIdentifier:string,showSpinner = true): Promise<OM.ProductCourseVm[]> {
                return CommonServices.get<OM.ProductCourseVm[]>(baseUrl + 'ProductCourse/GetClienteCourses',{ clienteIdentifier  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.BaseProductVm[]> {
                return CommonServices.get<OM.BaseProductVm[]>(baseUrl + 'ProductCourse/GetAll',{  }, showSpinner);

            }
        
        
    getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'ProductCourse/GetAllNameIdentifier',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                return CommonServices.get<OM.BaseProduct>(baseUrl + 'ProductCourse/GetById',{ identifier  }, showSpinner);

            }
        
        
    duplicaProdotto(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ProductCourse/DuplicaProdotto',{ identifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ProductCourse/Delete',{ identifier  }, showSpinner);

            }
                }

export let ProductCourseClient = new _ProductCourseClient();

class _ProductSpedibileClient {

        
    save(
        item:OM.ProductSpedibile,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'ProductSpedibile/Save', item ,{}, showSpinner );

            }
        
        
    getAll(showSpinner = true): Promise<OM.BaseProductVm[]> {
                return CommonServices.get<OM.BaseProductVm[]>(baseUrl + 'ProductSpedibile/GetAll',{  }, showSpinner);

            }
        
        
    getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'ProductSpedibile/GetAllNameIdentifier',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.BaseProduct> {
                return CommonServices.get<OM.BaseProduct>(baseUrl + 'ProductSpedibile/GetById',{ identifier  }, showSpinner);

            }
        
        
    duplicaProdotto(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ProductSpedibile/DuplicaProdotto',{ identifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ProductSpedibile/Delete',{ identifier  }, showSpinner);

            }
                }

export let ProductSpedibileClient = new _ProductSpedibileClient();

class _ShopCategoryClient {

        
    getAll(showSpinner = true): Promise<OM.ShopCategory[]> {
                return CommonServices.get<OM.ShopCategory[]>(baseUrl + 'ShopCategory/GetAll',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.ShopCategory> {
                return CommonServices.get<OM.ShopCategory>(baseUrl + 'ShopCategory/GetById',{ identifier  }, showSpinner);

            }
        
        
    getDetails(
        identifier:string,showSpinner = true): Promise<OM.ShopCategoryDetailsVm> {
                return CommonServices.get<OM.ShopCategoryDetailsVm>(baseUrl + 'ShopCategory/GetDetails',{ identifier  }, showSpinner);

            }
        
        
    getNameIdentifierList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'ShopCategory/GetNameIdentifierList',{  }, showSpinner);

            }
        
        
    save(
        item:OM.ShopCategory,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'ShopCategory/Save', item ,{}, showSpinner );

            }
        
        
    getUpsellCategoryIdentifier(showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'ShopCategory/GetUpsellCategoryIdentifier',{  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ShopCategory/Delete',{ identifier  }, showSpinner);

            }
        
        
    getCategoriesForCliente(
        clienteIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'ShopCategory/GetCategoriesForCliente',{ clienteIdentifier  }, showSpinner);

            }
                }

export let ShopCategoryClient = new _ShopCategoryClient();

class _ShoppingCartClient {

        
    addToCart(
        userIdentifier:string,
        offerIdentifier:string,
        quantity:number,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ShoppingCart/AddToCart',{ userIdentifier , offerIdentifier , quantity  }, showSpinner);

            }
        
        
    setItemQuantity(
        userIdentifier:string,
        offerIdentifier:string,
        quantity:number,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ShoppingCart/SetItemQuantity',{ userIdentifier , offerIdentifier , quantity  }, showSpinner);

            }
        
        
    clearCart(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ShoppingCart/ClearCart',{ userIdentifier  }, showSpinner);

            }
        
        
    getCartOfUser(
        userIdentifier:string,showSpinner = true): Promise<OM.ShoppingCartVm> {
                return CommonServices.get<OM.ShoppingCartVm>(baseUrl + 'ShoppingCart/GetCartOfUser',{ userIdentifier  }, showSpinner);

            }
        
        
    completeBuyCart(
        vm:OM.BuyCartRequestVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'ShoppingCart/CompleteBuyCart', vm ,{}, showSpinner );

            }
        
        
    buyCartBonifico(showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ShoppingCart/BuyCartBonifico',{  }, showSpinner);

            }
        
        
    saveTemporaryCart(
        vm:OM.SaveTemporaryCartVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'ShoppingCart/SaveTemporaryCart', vm ,{}, showSpinner );

            }
        
        
    getShoppingCartVm(
        cart:OM.ShoppingCart,showSpinner = true): Promise<OM.ShoppingCartVm> {
                return CommonServices.post<OM.ShoppingCartVm>(baseUrl + 'ShoppingCart/GetShoppingCartVm', cart ,{}, showSpinner );

            }
                }

export let ShoppingCartClient = new _ShoppingCartClient();

class _AcquistoClient {

        
    getByCliente(
        clienteIdentifier:string,showSpinner = true): Promise<OM.Vendita[]> {
                return CommonServices.get<OM.Vendita[]>(baseUrl + 'Acquisto/GetByCliente',{ clienteIdentifier  }, showSpinner);

            }
        
        
    saveStorno(
        acquistoIdentifier:string,
        percentualePuntiStorno:number,
        productLevelToApply:number,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Acquisto/SaveStorno',{ acquistoIdentifier , percentualePuntiStorno , productLevelToApply  }, showSpinner);

            }
        
        
    list(showSpinner = true): Promise<OM.AcquistoTableVm[]> {
                return CommonServices.get<OM.AcquistoTableVm[]>(baseUrl + 'Acquisto/List',{  }, showSpinner);

            }
        
        
    getByFilterVm(
        vm:OM.AcquistoListFilterVm,showSpinner = true): Promise<OM.PagedResultOfAcquistoTableVm> {
                return CommonServices.post<OM.PagedResultOfAcquistoTableVm>(baseUrl + 'Acquisto/GetByFilterVm', vm ,{}, showSpinner );

            }
        
        
    getFatturatoByPeriod(
        fromDate:string,
        toDate:string,
        userIdentifier:string,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'Acquisto/GetFatturatoByPeriod',{ fromDate , toDate , userIdentifier  }, showSpinner);

            }
        
        
    exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Acquisto/ExportExcel',{  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Acquisto/Delete',{ identifier  }, showSpinner);

            }
                }

export let AcquistoClient = new _AcquistoClient();

class _AppConfigClient {

        
    getConfig(showSpinner = true): Promise<OM.AppConfig> {
                return CommonServices.get<OM.AppConfig>(baseUrl + 'AppConfig/GetConfig',{  }, showSpinner);

            }
        
        
    save(
        item:OM.AppConfig,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'AppConfig/Save', item ,{}, showSpinner );

            }
        
        
    getModules(
        role:string,showSpinner = true): Promise<number[]> {
                return CommonServices.get<number[]>(baseUrl + 'AppConfig/GetModules',{ role  }, showSpinner);

            }
        
        
    canRequestPayment(
        userIdentifier:string,showSpinner = true): Promise<OM.CanRequestPaymentVm> {
                return CommonServices.get<OM.CanRequestPaymentVm>(baseUrl + 'AppConfig/CanRequestPayment',{ userIdentifier  }, showSpinner);

            }
        
        
    getPaymentRequestMinimumAmount(showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'AppConfig/GetPaymentRequestMinimumAmount',{  }, showSpinner);

            }
                }

export let AppConfigClient = new _AppConfigClient();

class _ChatRoomClient {

        
    getById(
        identifier:string,showSpinner = true): Promise<OM.ChatRoom> {
                return CommonServices.get<OM.ChatRoom>(baseUrl + 'ChatRoom/GetById',{ identifier  }, showSpinner);

            }
        
        
    getVmById(
        identifier:string,showSpinner = true): Promise<OM.ChatRoomVm> {
                return CommonServices.get<OM.ChatRoomVm>(baseUrl + 'ChatRoom/GetVmById',{ identifier  }, showSpinner);

            }
        
        
    getChatMessages(
        chatIdentifier:string,
        skip:number,
        take:number,showSpinner = true): Promise<OM.ChatMessage[]> {
                return CommonServices.get<OM.ChatMessage[]>(baseUrl + 'ChatRoom/GetChatMessages',{ chatIdentifier , skip , take  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.ChatRoomVm[]> {
                return CommonServices.get<OM.ChatRoomVm[]>(baseUrl + 'ChatRoom/GetAll',{  }, showSpinner);

            }
        
        
    save(
        item:OM.ChatRoom,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'ChatRoom/Save', item ,{}, showSpinner );

            }
        
        
    updateChatRoom(
        item:OM.ChatRoomVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'ChatRoom/UpdateChatRoom', item ,{}, showSpinner );

            }
        
        
    subscribe(
        identifier:string,
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ChatRoom/Subscribe',{ identifier , userIdentifier  }, showSpinner);

            }
        
        
    unSubscribe(
        identifier:string,
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ChatRoom/UnSubscribe',{ identifier , userIdentifier  }, showSpinner);

            }
        
        
    removeMessage(
        chatRoomIdentifier:string,
        messageIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ChatRoom/RemoveMessage',{ chatRoomIdentifier , messageIdentifier  }, showSpinner);

            }
        
        
    removeMessageMultiple(
        vm:OM.RemoveChatMessagesVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'ChatRoom/RemoveMessageMultiple', vm ,{}, showSpinner );

            }
        
        
    deleteChatRoom(
        chatRoomIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ChatRoom/DeleteChatRoom',{ chatRoomIdentifier  }, showSpinner);

            }
        
        
    disableChat(
        chatIdentifier:string,
        disable:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'ChatRoom/DisableChat',{ chatIdentifier , disable  }, showSpinner);

            }
                }

export let ChatRoomClient = new _ChatRoomClient();

class _ConfigurazionePrenotazioniClient {

        
    getByUser(
        userIdentifier:string,showSpinner = true): Promise<OM.ConfigurazionePrenotazioni> {
                return CommonServices.get<OM.ConfigurazionePrenotazioni>(baseUrl + 'ConfigurazionePrenotazioni/GetByUser',{ userIdentifier  }, showSpinner);

            }
        
        
    save(
        item:OM.ConfigurazionePrenotazioni,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'ConfigurazionePrenotazioni/Save', item ,{}, showSpinner );

            }
        
        
    getAvailabilitiesOfUser(
        userIdentifier:string,
        fromDate:string,
        toDate:string,showSpinner = true): Promise<OM.OrariPerPrenotareVm[]> {
                return CommonServices.get<OM.OrariPerPrenotareVm[]>(baseUrl + 'ConfigurazionePrenotazioni/GetAvailabilitiesOfUser',{ userIdentifier , fromDate , toDate  }, showSpinner);

            }
                }

export let ConfigurazionePrenotazioniClient = new _ConfigurazionePrenotazioniClient();

class _DashboardClient {

        
    getNazioniByPagamenti(
        userIdentifier:string,showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'Dashboard/GetNazioniByPagamenti',{ userIdentifier  }, showSpinner);

            }
        
        
    getDashPortafoglio(
        userIdentifier:string,
        nazione:string,showSpinner = true): Promise<OM.DashboardPortafoglioVm> {
                return CommonServices.get<OM.DashboardPortafoglioVm>(baseUrl + 'Dashboard/GetDashPortafoglio',{ userIdentifier , nazione  }, showSpinner);

            }
        
        
    getPerformanceChartValues(
        userIdentifier:string,
        start:string,
        end:string,showSpinner = true): Promise<OM.PerformanceChartValuesVm> {
                return CommonServices.get<OM.PerformanceChartValuesVm>(baseUrl + 'Dashboard/GetPerformanceChartValues',{ userIdentifier , start , end  }, showSpinner);

            }
        
        
    getGuadagniChartValues(
        userIdentifier:string,
        useNegatives:boolean,showSpinner = true): Promise<OM.GuadagniChartValuesVm> {
                return CommonServices.get<OM.GuadagniChartValuesVm>(baseUrl + 'Dashboard/GetGuadagniChartValues',{ userIdentifier , useNegatives  }, showSpinner);

            }
        
        
    getBestVenditori(
        userIdentifier:string,
        limit:number,
        start:string,
        end:string,showSpinner = true): Promise<OM.VenditoreBestVm[]> {
                return CommonServices.get<OM.VenditoreBestVm[]>(baseUrl + 'Dashboard/GetBestVenditori',{ userIdentifier , limit , start , end  }, showSpinner);

            }
        
        
    getGuadagniObiettivoMensileResult(
        userIdentifier:string,
        useNegatives:boolean,showSpinner = true): Promise<OM.ObiettivoMensileVm> {
                return CommonServices.get<OM.ObiettivoMensileVm>(baseUrl + 'Dashboard/GetGuadagniObiettivoMensileResult',{ userIdentifier , useNegatives  }, showSpinner);

            }
        
        
    getGuadagniObiettivoMensileByMonthResult(
        userIdentifier:string,
        month:number,
        year:number,
        useNegatives:boolean,showSpinner = true): Promise<OM.ObiettivoMensileVm> {
                return CommonServices.get<OM.ObiettivoMensileVm>(baseUrl + 'Dashboard/GetGuadagniObiettivoMensileByMonthResult',{ userIdentifier , month , year , useNegatives  }, showSpinner);

            }
        
        
    getDashProfile(
        userIdentifier:string,showSpinner = true): Promise<OM.DashboardProfileVm> {
                return CommonServices.get<OM.DashboardProfileVm>(baseUrl + 'Dashboard/GetDashProfile',{ userIdentifier  }, showSpinner);

            }
        
        
    getDashRicevute(
        userIdentifier:string,showSpinner = true): Promise<OM.RicevutaUtente[]> {
                return CommonServices.get<OM.RicevutaUtente[]>(baseUrl + 'Dashboard/GetDashRicevute',{ userIdentifier  }, showSpinner);

            }
        
        
    getDashSubUsers(
        userIdentifier:string,showSpinner = true): Promise<OM.UserCardVm[]> {
                return CommonServices.get<OM.UserCardVm[]>(baseUrl + 'Dashboard/GetDashSubUsers',{ userIdentifier  }, showSpinner);

            }
        
        
    hasSubUsers(
        userIdentifier:string,showSpinner = true): Promise<boolean> {
                return CommonServices.get<boolean>(baseUrl + 'Dashboard/HasSubUsers',{ userIdentifier  }, showSpinner);

            }
        
        
    getUserObiettivoCard(
        userIdentifier:string,
        start:string,
        end:string,showSpinner = true): Promise<OM.UserObiettivoCardVm> {
                return CommonServices.get<OM.UserObiettivoCardVm>(baseUrl + 'Dashboard/GetUserObiettivoCard',{ userIdentifier , start , end  }, showSpinner);

            }
        
        
    getSubUserObiettivoCard(
        userIdentifier:string,
        start:string,
        end:string,showSpinner = true): Promise<OM.UserObiettivoCardVm[]> {
                return CommonServices.get<OM.UserObiettivoCardVm[]>(baseUrl + 'Dashboard/GetSubUserObiettivoCard',{ userIdentifier , start , end  }, showSpinner);

            }
        
        
    exportDashboards(showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Dashboard/ExportDashboards',{  }, showSpinner);

            }
        
        
    exportDashboardMensile(showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Dashboard/ExportDashboardMensile',{  }, showSpinner);

            }
                }

export let DashboardClient = new _DashboardClient();

class _HelpTicketClient {

        
    assignToUser(
        chatIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'HelpTicket/AssignToUser',{ chatIdentifier , userIdentifier  }, showSpinner);

            }
        
        
    saveHelpTicket(
        vm:OM.SaveHelpTicketVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'HelpTicket/SaveHelpTicket', vm ,{}, showSpinner );

            }
        
        
    newTicketFromAdmin(
        vm:OM.SaveHelpTicketVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'HelpTicket/NewTicketFromAdmin', vm ,{}, showSpinner );

            }
        
        
    getAllPaginated(
        vm:OM.TicketListFilterVm,showSpinner = true): Promise<OM.PagedResultOfHelpTicketVm> {
                return CommonServices.post<OM.PagedResultOfHelpTicketVm>(baseUrl + 'HelpTicket/GetAllPaginated', vm ,{}, showSpinner );

            }
        
        
    getAll(showSpinner = true): Promise<OM.HelpTicketVm[]> {
                return CommonServices.get<OM.HelpTicketVm[]>(baseUrl + 'HelpTicket/GetAll',{  }, showSpinner);

            }
        
        
    canOpenTicketV2(showSpinner = true): Promise<OM.GetOrariAperturaTicketVmV2> {
                return CommonServices.get<OM.GetOrariAperturaTicketVmV2>(baseUrl + 'HelpTicket/CanOpenTicketV2',{  }, showSpinner);

            }
        
        
    exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'HelpTicket/ExportExcel',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.ChatRoom> {
                return CommonServices.get<OM.ChatRoom>(baseUrl + 'HelpTicket/GetById',{ identifier  }, showSpinner);

            }
        
        
    getByClienteIdentifier(
        clienteIdentifier:string,showSpinner = true): Promise<OM.HelpTicketVm[]> {
                return CommonServices.get<OM.HelpTicketVm[]>(baseUrl + 'HelpTicket/GetByClienteIdentifier',{ clienteIdentifier  }, showSpinner);

            }
        
        
    chiudiTicket(
        ticketIdentifier:string,
        disable:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'HelpTicket/ChiudiTicket',{ ticketIdentifier , disable  }, showSpinner);

            }
        
        
    setGestitoDa(
        ticketIdentifier:string,
        value:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'HelpTicket/SetGestitoDa',{ ticketIdentifier , value  }, showSpinner);

            }
        
        
    setAssignedUser(
        ticketIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'HelpTicket/SetAssignedUser',{ ticketIdentifier , userIdentifier  }, showSpinner);

            }
        
        
    getExternals(showSpinner = true): Promise<OM.HelpTicketVm[]> {
                return CommonServices.get<OM.HelpTicketVm[]>(baseUrl + 'HelpTicket/GetExternals',{  }, showSpinner);

            }
                }

export let HelpTicketClient = new _HelpTicketClient();

class _HtmlTextConfigClient {

        
    getConfig(showSpinner = true): Promise<OM.HtmlTextConfig> {
                return CommonServices.get<OM.HtmlTextConfig>(baseUrl + 'HtmlTextConfig/GetConfig',{  }, showSpinner);

            }
        
        
    save(
        item:OM.HtmlTextConfig,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'HtmlTextConfig/Save', item ,{}, showSpinner );

            }
                }

export let HtmlTextConfigClient = new _HtmlTextConfigClient();

class _NetworkClient {

        
    getDescendants(
        userIdentifier:string,showSpinner = true): Promise<OM.NetworkUserVM[]> {
                return CommonServices.get<OM.NetworkUserVM[]>(baseUrl + 'Network/GetDescendants',{ userIdentifier  }, showSpinner);

            }
        
        
    getGestioneDescendantsOf(
        userIdentifier:string,
        showClienti:boolean,
        showLead:boolean,showSpinner = true): Promise<OM.NetworkUserVM[]> {
                return CommonServices.get<OM.NetworkUserVM[]>(baseUrl + 'Network/GetGestioneDescendantsOf',{ userIdentifier , showClienti , showLead  }, showSpinner);

            }
        
        
    getCommercialeDescendantsOf(
        userIdentifier:string,
        showClienti:boolean,
        showLead:boolean,showSpinner = true): Promise<OM.NetworkUserVM[]> {
                return CommonServices.get<OM.NetworkUserVM[]>(baseUrl + 'Network/GetCommercialeDescendantsOf',{ userIdentifier , showClienti , showLead  }, showSpinner);

            }
        
        
    getNetworkUser(
        userIdentifier:string,showSpinner = true): Promise<OM.NetworkUserVM> {
                return CommonServices.get<OM.NetworkUserVM>(baseUrl + 'Network/GetNetworkUser',{ userIdentifier  }, showSpinner);

            }
        
        
    getFirstLineOf(
        userIdentifier:string,showSpinner = true): Promise<OM.NetworkUserVM[]> {
                return CommonServices.get<OM.NetworkUserVM[]>(baseUrl + 'Network/GetFirstLineOf',{ userIdentifier  }, showSpinner);

            }
                }

export let NetworkClient = new _NetworkClient();

class _PayPalClient {

        
    createIntentFromOffer(
        offerIdentifier:string,
        clientId:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'PayPal/CreateIntentFromOffer',{ offerIdentifier , clientId  }, showSpinner);

            }
        
        
    completeOrder(
        orderId:string,
        clientId:string,showSpinner = true): Promise<OM.PayPalCaptureOrderResponse> {
                return CommonServices.get<OM.PayPalCaptureOrderResponse>(baseUrl + 'PayPal/CompleteOrder',{ orderId , clientId  }, showSpinner);

            }
        
        
    getOfferCurrency(
        offerIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'PayPal/GetOfferCurrency',{ offerIdentifier  }, showSpinner);

            }
                }

export let PayPalClient = new _PayPalClient();

class _PrenotazioneClient {

        
    getByUser(
        userIdentifier:string,showSpinner = true): Promise<OM.Prenotazione[]> {
                return CommonServices.get<OM.Prenotazione[]>(baseUrl + 'Prenotazione/GetByUser',{ userIdentifier  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Prenotazione> {
                return CommonServices.get<OM.Prenotazione>(baseUrl + 'Prenotazione/GetById',{ identifier  }, showSpinner);

            }
        
        
    getByCliente(
        clienteIdentifier:string,showSpinner = true): Promise<OM.PrenotazioneForListVm[]> {
                return CommonServices.get<OM.PrenotazioneForListVm[]>(baseUrl + 'Prenotazione/GetByCliente',{ clienteIdentifier  }, showSpinner);

            }
        
        
    getByReteGestione(
        userIdentifier:string,showSpinner = true): Promise<OM.PrenotazioneForListVm[]> {
                return CommonServices.get<OM.PrenotazioneForListVm[]>(baseUrl + 'Prenotazione/GetByReteGestione',{ userIdentifier  }, showSpinner);

            }
        
        
    getByCentroFumo(
        userIdentifier:string,showSpinner = true): Promise<OM.PrenotazioneForListVm[]> {
                return CommonServices.get<OM.PrenotazioneForListVm[]>(baseUrl + 'Prenotazione/GetByCentroFumo',{ userIdentifier  }, showSpinner);

            }
        
        
    getByCentroFumoInterval(
        userIdentifier:string,
        startDate:string,
        endDate:string,showSpinner = true): Promise<OM.PrenotazioneForListVm[]> {
                return CommonServices.get<OM.PrenotazioneForListVm[]>(baseUrl + 'Prenotazione/GetByCentroFumoInterval',{ userIdentifier , startDate , endDate  }, showSpinner);

            }
        
        
    getByCentroFumoList(
        vm:OM.GetPrenotazioniFilterVm,showSpinner = true): Promise<OM.PagedResultOfPrenotazioneForListVm> {
                return CommonServices.post<OM.PagedResultOfPrenotazioneForListVm>(baseUrl + 'Prenotazione/GetByCentroFumoList', vm ,{}, showSpinner );

            }
        
        
    iniziaTrattamento(
        prenotazioneIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Prenotazione/IniziaTrattamento',{ prenotazioneIdentifier  }, showSpinner);

            }
        
        
    salvaDatiTrattamento(
        vm:OM.SaveStatoMacchinaAntismokingVm,showSpinner = true): Promise<OM.StatoMacchinaAntismoking> {
                return CommonServices.post<OM.StatoMacchinaAntismoking>(baseUrl + 'Prenotazione/SalvaDatiTrattamento', vm ,{}, showSpinner );

            }
        
        
    respingiPrenotazione(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Prenotazione/RespingiPrenotazione',{ identifier  }, showSpinner);

            }
        
        
    deletePrenotazione(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Prenotazione/DeletePrenotazione',{ identifier  }, showSpinner);

            }
        
        
    save(
        item:OM.Prenotazione,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Prenotazione/Save', item ,{}, showSpinner );

            }
        
        
    makePrenotazione(
        vm:OM.MakePrenotazioneVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Prenotazione/MakePrenotazione', vm ,{}, showSpinner );

            }
        
        
    spostaPrenotazione(
        vm:OM.MakePrenotazioneVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Prenotazione/SpostaPrenotazione', vm ,{}, showSpinner );

            }
        
        
    concludiPrenotazione(
        prenotazioneIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Prenotazione/ConcludiPrenotazione',{ prenotazioneIdentifier  }, showSpinner);

            }
                }

export let PrenotazioneClient = new _PrenotazioneClient();

class _ProvvigioniClient {

        
    list(
        vm:OM.ProvvigioniListFilterVm,showSpinner = true): Promise<OM.PagedResultOfProvvigioniListVm> {
                return CommonServices.post<OM.PagedResultOfProvvigioniListVm>(baseUrl + 'Provvigioni/List', vm ,{}, showSpinner );

            }
        
        
    getByFilterVm(
        vm:OM.ProvvigioniFilterVm,showSpinner = true): Promise<OM.PagedResultOfProvvigioniListVm> {
                return CommonServices.post<OM.PagedResultOfProvvigioniListVm>(baseUrl + 'Provvigioni/GetByFilterVm', vm ,{}, showSpinner );

            }
        
        
    exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Provvigioni/ExportExcel',{  }, showSpinner);

            }
        
        
    deleteById(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Provvigioni/DeleteById',{ identifier  }, showSpinner);

            }
        
        
    reportFineMese(
        userIdentifier:string,
        mese:number,
        anno:number,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Provvigioni/ReportFineMese',{ userIdentifier , mese , anno  }, showSpinner);

            }
        
        
    simula(
        vm:OM.SimulaProvvigioniRequestVm,showSpinner = true): Promise<OM.QualificaProvvigioni> {
                return CommonServices.post<OM.QualificaProvvigioni>(baseUrl + 'Provvigioni/Simula', vm ,{}, showSpinner );

            }
                }

export let ProvvigioniClient = new _ProvvigioniClient();

class _QualificaProvvigioniConfigClient {

        
    getAll(showSpinner = true): Promise<OM.QualificaProvvigioniConfig[]> {
                return CommonServices.get<OM.QualificaProvvigioniConfig[]>(baseUrl + 'QualificaProvvigioniConfig/GetAll',{  }, showSpinner);

            }
        
        
    getQualificheList(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'QualificaProvvigioniConfig/GetQualificheList',{  }, showSpinner);

            }
        
        
    deleteById(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'QualificaProvvigioniConfig/DeleteById',{ identifier  }, showSpinner);

            }
        
        
    saveAll(
        list:OM.QualificaProvvigioniConfig[],showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'QualificaProvvigioniConfig/SaveAll', list ,{}, showSpinner );

            }
                }

export let QualificaProvvigioniConfigClient = new _QualificaProvvigioniConfigClient();

class _RicevuteClienteClient {

        
    inviaMail(
        ricevutaIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'RicevuteCliente/InviaMail', ricevutaIdentifier ,{}, showSpinner );

            }
        
        
    exportRicevutaCliente(
        acquistoIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'RicevuteCliente/ExportRicevutaCliente',{ acquistoIdentifier  }, showSpinner);

            }
        
        
    list(showSpinner = true): Promise<OM.RicevutaCliente[]> {
                return CommonServices.get<OM.RicevutaCliente[]>(baseUrl + 'RicevuteCliente/List',{  }, showSpinner);

            }
                }

export let RicevuteClienteClient = new _RicevuteClienteClient();

class _RicevuteUtenteClient {

        
    add(
        vm:OM.RicevutaUtenteInsertVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'RicevuteUtente/Add', vm ,{}, showSpinner );

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'RicevuteUtente/Delete',{ identifier  }, showSpinner);

            }
        
        
    download(
        ricevutaIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'RicevuteUtente/Download',{ ricevutaIdentifier  }, showSpinner);

            }
                }

export let RicevuteUtenteClient = new _RicevuteUtenteClient();

class _RichiestaPagamentoUserClient {

        
    getAll(showSpinner = true): Promise<OM.RichiestaPagamentoUser[]> {
                return CommonServices.get<OM.RichiestaPagamentoUser[]>(baseUrl + 'RichiestaPagamentoUser/GetAll',{  }, showSpinner);

            }
        
        
    generaRitenutaAcconto(
        richiestaPagamentoIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'RichiestaPagamentoUser/GeneraRitenutaAcconto',{ richiestaPagamentoIdentifier  }, showSpinner);

            }
        
        
    confermaRichiestaPagamento(
        vm:OM.RicevutaUtenteInsertVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'RichiestaPagamentoUser/ConfermaRichiestaPagamento', vm ,{}, showSpinner );

            }
        
        
    annullaRichiestaPagamento(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'RichiestaPagamentoUser/AnnullaRichiestaPagamento',{ userIdentifier  }, showSpinner);

            }
                }

export let RichiestaPagamentoUserClient = new _RichiestaPagamentoUserClient();

class _RisposteQuestionarioClient {

        
    getByDeviceId(
        deviceId:string,showSpinner = true): Promise<OM.RisposteQuestionario[]> {
                return CommonServices.get<OM.RisposteQuestionario[]>(baseUrl + 'RisposteQuestionario/GetByDeviceId',{ deviceId  }, showSpinner);

            }
                }

export let RisposteQuestionarioClient = new _RisposteQuestionarioClient();

class _ScheduledClient {

        
    calcoloQualifiche(
        psw:string,
        trimestrale:boolean,
        semestrale:boolean,
        annuale:boolean,
        mese:number,
        anno:number,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Scheduled/CalcoloQualifiche',{ psw , trimestrale , semestrale , annuale , mese , anno  }, showSpinner);

            }
        
        
    reportFineMese(
        psw:string,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Scheduled/ReportFineMese',{ psw  }, showSpinner);

            }
                }

export let ScheduledClient = new _ScheduledClient();

class _StripeClient {

        
    createIntentFromBuyCartRequestVm(
        vm:OM.BuyCartRequestVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Stripe/CreateIntentFromBuyCartRequestVm', vm ,{}, showSpinner );

            }
        
        
    createIntentFromOffer(
        offerIdentifier:string,
        stripePublicKey:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Stripe/CreateIntentFromOffer',{ offerIdentifier , stripePublicKey  }, showSpinner);

            }
        
        
    createIntentFromCart(
        stripePublicKey:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Stripe/CreateIntentFromCart',{ stripePublicKey  }, showSpinner);

            }
        
        
    getSavedCards(
        stripePublicKey:string,showSpinner = true): Promise<OM.StripeCardDetailVm[]> {
                return CommonServices.get<OM.StripeCardDetailVm[]>(baseUrl + 'Stripe/GetSavedCards',{ stripePublicKey  }, showSpinner);

            }
        
        
    addCardToCustomer(
        paymentMethodId:string,
        stripePublicKey:string,showSpinner = true): Promise<OM.StripeCardDetailVm> {
                return CommonServices.get<OM.StripeCardDetailVm>(baseUrl + 'Stripe/AddCardToCustomer',{ paymentMethodId , stripePublicKey  }, showSpinner);

            }
        
        
    removeCardFromCustomer(
        paymentMethodId:string,
        stripePublicKey:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Stripe/RemoveCardFromCustomer',{ paymentMethodId , stripePublicKey  }, showSpinner);

            }
                }

export let StripeClient = new _StripeClient();

class _TicketPrenotazioneClient {

        
    getAll(
        vm:OM.TicketPrenotazioneListFilterVm,showSpinner = true): Promise<OM.PagedResultOfTicketPrenotazione> {
                return CommonServices.post<OM.PagedResultOfTicketPrenotazione>(baseUrl + 'TicketPrenotazione/GetAll', vm ,{}, showSpinner );

            }
        
        
    deleteById(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'TicketPrenotazione/DeleteById',{ identifier  }, showSpinner);

            }
        
        
    saveTicket(
        item:OM.TicketPrenotazione,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'TicketPrenotazione/SaveTicket', item ,{}, showSpinner );

            }
        
        
    getAvailableTickets(
        userIdentifier:string,showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'TicketPrenotazione/GetAvailableTickets',{ userIdentifier  }, showSpinner);

            }
        
        
    getAvailableTicketsWithRole(
        userIdentifier:string,showSpinner = true): Promise<OM.TicketPrenotazioneWithRoleVm[]> {
                return CommonServices.get<OM.TicketPrenotazioneWithRoleVm[]>(baseUrl + 'TicketPrenotazione/GetAvailableTicketsWithRole',{ userIdentifier  }, showSpinner);

            }
                }

export let TicketPrenotazioneClient = new _TicketPrenotazioneClient();

class _BaseUserClient {

        
    update(
        item:OM.BaseUser,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'BaseUser/Update', item ,{}, showSpinner );

            }
        
        
    getListForNetwork(
        roleFilter:string,
        userToExclude:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'BaseUser/GetListForNetwork',{ roleFilter , userToExclude  }, showSpinner);

            }
        
        
    assignToUserCommerciale(
        vm:OM.AssignToVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'BaseUser/AssignToUserCommerciale', vm ,{}, showSpinner );

            }
        
        
    assignToUserGestione(
        vm:OM.AssignToVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'BaseUser/AssignToUserGestione', vm ,{}, showSpinner );

            }
        
        
    acceptGestione(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BaseUser/AcceptGestione',{ userIdentifier  }, showSpinner);

            }
        
        
    voidGestione(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BaseUser/VoidGestione',{ userIdentifier  }, showSpinner);

            }
        
        
    setPreferredCulture(
        culture:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'BaseUser/SetPreferredCulture',{ culture  }, showSpinner);

            }
        
        
    getShippingAddress(
        userIdentifier:string,showSpinner = true): Promise<OM.Address> {
                return CommonServices.get<OM.Address>(baseUrl + 'BaseUser/GetShippingAddress',{ userIdentifier  }, showSpinner);

            }
                }

export let BaseUserClient = new _BaseUserClient();

class _ClienteClient {

        
    save(
        vm:OM.UpdateClienteVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Cliente/Save', vm ,{}, showSpinner );

            }
        
        
    getByIdVm(
        identifier:string,showSpinner = true): Promise<OM.UpdateClienteVm> {
                return CommonServices.get<OM.UpdateClienteVm>(baseUrl + 'Cliente/GetByIdVm',{ identifier  }, showSpinner);

            }
        
        
    promoteToSegnalatore(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/PromoteToSegnalatore',{ identifier  }, showSpinner);

            }
        
        
    promoteToCliente(
        identifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Cliente/PromoteToCliente',{ identifier  }, showSpinner);

            }
        
        
    attivaOffertaFromBackend(
        clienteIdentifier:string,
        offertaIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/AttivaOffertaFromBackend',{ clienteIdentifier , offertaIdentifier  }, showSpinner);

            }
        
        
    attivaOffertaMultipleFromBackend(
        vm:OM.AttivaOffertaMultipleFromBackendRequestVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Cliente/AttivaOffertaMultipleFromBackend', vm ,{}, showSpinner );

            }
        
        
    removeComment(
        commentIdentifier:string,
        clienteIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/RemoveComment',{ commentIdentifier , clienteIdentifier  }, showSpinner);

            }
        
        
    getByFilter(
        vm:OM.ClientiListFilterVm,showSpinner = true): Promise<OM.PagedResultOfClienteVm> {
                return CommonServices.post<OM.PagedResultOfClienteVm>(baseUrl + 'Cliente/GetByFilter', vm ,{}, showSpinner );

            }
        
        
    setPromoCode(
        promocode:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/SetPromoCode',{ promocode  }, showSpinner);

            }
        
        
    updateEmail(
        email:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/UpdateEmail',{ email  }, showSpinner);

            }
        
        
    setPassword(
        clienteIdentifier:string,
        password:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/SetPassword',{ clienteIdentifier , password  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.ClienteVm[]> {
                return CommonServices.get<OM.ClienteVm[]>(baseUrl + 'Cliente/GetAll',{  }, showSpinner);

            }
        
        
    exportExcel(
        userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Cliente/ExportExcel',{ userIdentifier  }, showSpinner);

            }
        
        
    getNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Cliente/GetNameIdentifiers',{  }, showSpinner);

            }
        
        
    searchCliente(
        search:string,
        userIdentifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Cliente/SearchCliente',{ search , userIdentifier  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Cliente> {
                return CommonServices.get<OM.Cliente>(baseUrl + 'Cliente/GetById',{ identifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Cliente/Delete',{ identifier  }, showSpinner);

            }
                }

export let ClienteClient = new _ClienteClient();

class _CollaboratoreClient {

        
    save(
        vm:OM.UpdateCollaboratoreVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Collaboratore/Save', vm ,{}, showSpinner );

            }
        
        
    showBadge(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Collaboratore/ShowBadge',{ userIdentifier  }, showSpinner);

            }
        
        
    getByIdVm(
        identifier:string,showSpinner = true): Promise<OM.UpdateCollaboratoreVm> {
                return CommonServices.get<OM.UpdateCollaboratoreVm>(baseUrl + 'Collaboratore/GetByIdVm',{ identifier  }, showSpinner);

            }
        
        
    promoteToCollaboratore(
        identifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Collaboratore/PromoteToCollaboratore',{ identifier  }, showSpinner);

            }
        
        
    getLatLongsByNazione(
        nazione:string,showSpinner = true): Promise<OM.LatLongIdentifierVm[]> {
                return CommonServices.get<OM.LatLongIdentifierVm[]>(baseUrl + 'Collaboratore/GetLatLongsByNazione',{ nazione  }, showSpinner);

            }
        
        
    getListDottori(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetListDottori',{  }, showSpinner);

            }
        
        
    getDescendantsManagersNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetDescendantsManagersNameIdentifier',{  }, showSpinner);

            }
        
        
    getManagerNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetManagerNameIdentifier',{  }, showSpinner);

            }
        
        
    getCentroFumoByRegione(
        regione:string,showSpinner = true): Promise<OM.CentroFumoDetailsVm[]> {
                return CommonServices.get<OM.CentroFumoDetailsVm[]>(baseUrl + 'Collaboratore/GetCentroFumoByRegione',{ regione  }, showSpinner);

            }
        
        
    getCentroFumoDetails(
        identifier:string,showSpinner = true): Promise<OM.CentroFumoDetailsVm> {
                return CommonServices.get<OM.CentroFumoDetailsVm>(baseUrl + 'Collaboratore/GetCentroFumoDetails',{ identifier  }, showSpinner);

            }
        
        
    getCentriFumoByCommerciale(
        identifier:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetCentriFumoByCommerciale',{ identifier  }, showSpinner);

            }
        
        
    updateUser(
        vm:OM.UpdateUserVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Collaboratore/UpdateUser', vm ,{}, showSpinner );

            }
        
        
    create(
        vm:OM.CreateUserVm,showSpinner = true): Promise<OM.Collaboratore> {
                return CommonServices.post<OM.Collaboratore>(baseUrl + 'Collaboratore/Create', vm ,{}, showSpinner );

            }
        
        
    getAll(showSpinner = true): Promise<OM.CollaboratoreListVm[]> {
                return CommonServices.get<OM.CollaboratoreListVm[]>(baseUrl + 'Collaboratore/GetAll',{  }, showSpinner);

            }
        
        
    exportExcel(showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.get<OM.NameIdentifier>(baseUrl + 'Collaboratore/ExportExcel',{  }, showSpinner);

            }
        
        
    getQualifiche(showSpinner = true): Promise<OM.QualificaProvvigioniConfig[]> {
                return CommonServices.get<OM.QualificaProvvigioniConfig[]>(baseUrl + 'Collaboratore/GetQualifiche',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Collaboratore> {
                return CommonServices.get<OM.Collaboratore>(baseUrl + 'Collaboratore/GetById',{ identifier  }, showSpinner);

            }
        
        
    getProvvigioni(
        identifier:string,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'Collaboratore/GetProvvigioni',{ identifier  }, showSpinner);

            }
        
        
    delete(
        identifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Collaboratore/Delete',{ identifier  }, showSpinner);

            }
        
        
    register(
        promoRegisterVM:OM.PromoRegisterVM,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Collaboratore/Register', promoRegisterVM ,{}, showSpinner );

            }
        
        
    confirmEmail(
        userIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Collaboratore/ConfirmEmail',{ userIdentifier  }, showSpinner);

            }
        
        
    getUsersWithReferral(showSpinner = true): Promise<OM.UserWithReferralVM[]> {
                return CommonServices.get<OM.UserWithReferralVM[]>(baseUrl + 'Collaboratore/GetUsersWithReferral',{  }, showSpinner);

            }
        
        
    getAllNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetAllNameIdentifier',{  }, showSpinner);

            }
        
        
    getCentroFumoNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetCentroFumoNameIdentifier',{  }, showSpinner);

            }
        
        
    getDescendantsNameIdentifier(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Collaboratore/GetDescendantsNameIdentifier',{  }, showSpinner);

            }
        
        
    setObiettivoMensile(
        userIdentifier:string,
        obiettivo:number,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Collaboratore/SetObiettivoMensile',{ userIdentifier , obiettivo  }, showSpinner);

            }
                }

export let CollaboratoreClient = new _CollaboratoreClient();

class _LeadClient {

        
    save(
        vm:OM.UpdateLeadVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Lead/Save', vm ,{}, showSpinner );

            }
        
        
    addLinkedAccount(
        vm:OM.LoginVm,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.post<OM.NameIdentifier>(baseUrl + 'Lead/AddLinkedAccount', vm ,{}, showSpinner );

            }
        
        
    removeLinkedAccount(
        removeIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/RemoveLinkedAccount',{ removeIdentifier  }, showSpinner);

            }
        
        
    getLeadInAccettazione(
        showAccepted:boolean,showSpinner = true): Promise<OM.LeadInAccettazioneVm[]> {
                return CommonServices.get<OM.LeadInAccettazioneVm[]>(baseUrl + 'Lead/GetLeadInAccettazione',{ showAccepted  }, showSpinner);

            }
        
        
    saveDatiFumo(
        vm:OM.UpdateCalcoliFumoVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/SaveDatiFumo', vm ,{}, showSpinner );

            }
        
        
    updateContactAddress(
        vm:OM.UpdateAddressVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/UpdateContactAddress', vm ,{}, showSpinner );

            }
        
        
    saveNewLeadVm(
        vm:OM.NewLeadVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Lead/SaveNewLeadVm', vm ,{}, showSpinner );

            }
        
        
    getProfonditaNodo(
        fromNode:string,
        toNode:string,showSpinner = true): Promise<number> {
                return CommonServices.get<number>(baseUrl + 'Lead/GetProfonditaNodo',{ fromNode , toNode  }, showSpinner);

            }
        
        
    setStatoCommerciale(
        leadIdentifier:string,
        stato:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/SetStatoCommerciale',{ leadIdentifier , stato  }, showSpinner);

            }
        
        
    updateCodiceFiscale(
        leadIdentifier:string,
        newCodFisc:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/UpdateCodiceFiscale',{ leadIdentifier , newCodFisc  }, showSpinner);

            }
        
        
    updateLuogoDataNascita(
        vm:OM.UpdateLuogoDataNascitaVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/UpdateLuogoDataNascita', vm ,{}, showSpinner );

            }
        
        
    updateFiscalAddress(
        vm:OM.UpdateAddressVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/UpdateFiscalAddress', vm ,{}, showSpinner );

            }
        
        
    saveContactEmail(
        leadIdentifier:string,
        newEmail:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/SaveContactEmail',{ leadIdentifier , newEmail  }, showSpinner);

            }
        
        
    getNameIdentifiers(showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Lead/GetNameIdentifiers',{  }, showSpinner);

            }
        
        
    requestResetPassword(
        userEmail:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/RequestResetPassword',{ userEmail  }, showSpinner);

            }
        
        
    resetPassword(
        model:OM.ResetPasswordVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/ResetPassword', model ,{}, showSpinner );

            }
        
        
    confirmEmail(
        userIdentifier:string,
        confirmationCode:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/ConfirmEmail',{ userIdentifier , confirmationCode  }, showSpinner);

            }
        
        
    getByIdVm(
        identifier:string,showSpinner = true): Promise<OM.UpdateLeadVm> {
                return CommonServices.get<OM.UpdateLeadVm>(baseUrl + 'Lead/GetByIdVm',{ identifier  }, showSpinner);

            }
        
        
    getLists(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'Lead/GetLists',{  }, showSpinner);

            }
        
        
    getById(
        identifier:string,showSpinner = true): Promise<OM.Lead> {
                return CommonServices.get<OM.Lead>(baseUrl + 'Lead/GetById',{ identifier  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.Lead[]> {
                return CommonServices.get<OM.Lead[]>(baseUrl + 'Lead/GetAll',{  }, showSpinner);

            }
        
        
    getStoricoAssegnazioni(
        leadIdentifier:string,showSpinner = true): Promise<OM.DateValueOfStoricoAssegnazione[]> {
                return CommonServices.get<OM.DateValueOfStoricoAssegnazione[]>(baseUrl + 'Lead/GetStoricoAssegnazioni',{ leadIdentifier  }, showSpinner);

            }
        
        
    getAssegnazioni(
        startDate:string,
        endDate:string,
        userIdentifier:string,
        descendants:boolean,showSpinner = true): Promise<OM.StoricoAssegnazioneVm[]> {
                return CommonServices.get<OM.StoricoAssegnazioneVm[]>(baseUrl + 'Lead/GetAssegnazioni',{ startDate , endDate , userIdentifier , descendants  }, showSpinner);

            }
        
        
    setLavorato(
        leadIdentifier:string,
        value:boolean,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/SetLavorato',{ leadIdentifier , value  }, showSpinner);

            }
        
        
    getTelephoneNumber(
        leadIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/GetTelephoneNumber',{ leadIdentifier  }, showSpinner);

            }
        
        
    getScadenze(
        startDate:string,
        endDate:string,
        userIdentifier:string,
        descendants:boolean,
        showLavorati:boolean,showSpinner = true): Promise<OM.GetScadenzeLeadVm> {
                return CommonServices.get<OM.GetScadenzeLeadVm>(baseUrl + 'Lead/GetScadenze',{ startDate , endDate , userIdentifier , descendants , showLavorati  }, showSpinner);

            }
        
        
    getScadenza(
        leadIdentifier:string,
        scadenzaIdentifier:string,showSpinner = true): Promise<OM.LeadScadenzaVm> {
                return CommonServices.get<OM.LeadScadenzaVm>(baseUrl + 'Lead/GetScadenza',{ leadIdentifier , scadenzaIdentifier  }, showSpinner);

            }
        
        
    getByList(
        vm:OM.LeadListFilterVm,showSpinner = true): Promise<OM.PagedResultOfLeadTableVm> {
                return CommonServices.post<OM.PagedResultOfLeadTableVm>(baseUrl + 'Lead/GetByList', vm ,{}, showSpinner );

            }
        
        
    exportLeads(
        vm:OM.LeadListFilterVm,showSpinner = true): Promise<OM.NameIdentifier> {
                return CommonServices.post<OM.NameIdentifier>(baseUrl + 'Lead/ExportLeads', vm ,{}, showSpinner );

            }
        
        
    create(
        item:OM.Lead,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Lead/Create', item ,{}, showSpinner );

            }
        
        
    saveAnagrafica(
        item:OM.Lead,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/SaveAnagrafica', item ,{}, showSpinner );

            }
        
        
    createList(
        listname:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/CreateList',{ listname  }, showSpinner);

            }
        
        
    removeList(
        listname:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/RemoveList',{ listname  }, showSpinner);

            }
        
        
    saveComment(
        vm:OM.TextIdentifier,showSpinner = true): Promise<OM.Comment> {
                return CommonServices.post<OM.Comment>(baseUrl + 'Lead/SaveComment', vm ,{}, showSpinner );

            }
        
        
    saveNota(
        vm:OM.TextIdentifier,showSpinner = true): Promise<OM.Comment> {
                return CommonServices.post<OM.Comment>(baseUrl + 'Lead/SaveNota', vm ,{}, showSpinner );

            }
        
        
    saveAction(
        vm:OM.SaveLeadActionVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/SaveAction', vm ,{}, showSpinner );

            }
        
        
    changeStatus(
        leadIdentifier:string,
        status:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/ChangeStatus',{ leadIdentifier , status  }, showSpinner);

            }
        
        
    changeSubStatus(
        leadIdentifier:string,
        subStatus:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/ChangeSubStatus',{ leadIdentifier , subStatus  }, showSpinner);

            }
        
        
    assignToList(
        leadIdentifier:string,
        list:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/AssignToList',{ leadIdentifier , list  }, showSpinner);

            }
        
        
    assignToNone(
        leadIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/AssignToNone',{ leadIdentifier  }, showSpinner);

            }
        
        
    assignToNoneMultiple(
        leadList:string[],showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/AssignToNoneMultiple', leadList ,{}, showSpinner );

            }
        
        
    assignGestioneMultipleToUser(
        vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/AssignGestioneMultipleToUser', vm ,{}, showSpinner );

            }
        
        
    assignMultipleToList(
        vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/AssignMultipleToList', vm ,{}, showSpinner );

            }
        
        
    setSubStatusToMultiple(
        vm:OM.MultipleLeadsActionVm,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/SetSubStatusToMultiple', vm ,{}, showSpinner );

            }
        
        
    accettaGestione(
        leadIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/AccettaGestione',{ leadIdentifier  }, showSpinner);

            }
        
        
    accettaGestioneMultiple(
        leads:string[],showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/AccettaGestioneMultiple', leads ,{}, showSpinner );

            }
        
        
    assignToUser(
        leadIdentifier:string,
        userIdentifier:string,showSpinner = true): Promise<string> {
                return CommonServices.get<string>(baseUrl + 'Lead/AssignToUser',{ leadIdentifier , userIdentifier  }, showSpinner);

            }
        
        
    deleteAttachment(
        leadIdentifier:string,
        url:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/DeleteAttachment',{ leadIdentifier , url  }, showSpinner);

            }
        
        
    delete(
        leadIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/Delete',{ leadIdentifier  }, showSpinner);

            }
        
        
    searchByContactName(
        search:string,showSpinner = true): Promise<OM.NameIdentifier[]> {
                return CommonServices.get<OM.NameIdentifier[]>(baseUrl + 'Lead/SearchByContactName',{ search  }, showSpinner);

            }
        
        
    checkNumber(
        checkthis:OM.CheckNumberVm,showSpinner = true): Promise<boolean> {
                return CommonServices.post<boolean>(baseUrl + 'Lead/CheckNumber', checkthis ,{}, showSpinner );

            }
        
        
    upgradeToCliente(
        vm:OM.UpgradeLeadVm,showSpinner = true): Promise<string> {
                return CommonServices.post<string>(baseUrl + 'Lead/UpgradeToCliente', vm ,{}, showSpinner );

            }
        
        
    removeComment(
        commentIdentifier:string,
        leadIdentifier:string,showSpinner = true): Promise<void> {
                return CommonServices.get<void>(baseUrl + 'Lead/RemoveComment',{ commentIdentifier , leadIdentifier  }, showSpinner);

            }
        
        
    getBySubStatusAsColonna(showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'Lead/GetBySubStatusAsColonna', {},{}, showSpinner );

            }
        
        
    getByStatusAsColonne(
        userIdentifier:string,
        descendants:boolean,showSpinner = true): Promise<OM.LeadColonneVm> {
                return CommonServices.get<OM.LeadColonneVm>(baseUrl + 'Lead/GetByStatusAsColonne',{ userIdentifier , descendants  }, showSpinner);

            }
                }

export let LeadClient = new _LeadClient();

class _LocalizationClient {

        
    saveLocalizedValue(
        item:OM.KeyValuePairOfStringAndString,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Localization/SaveLocalizedValue', item ,{}, showSpinner );

            }
        
        
    getAppDictionary(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                return CommonServices.get<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAppDictionary',{  }, showSpinner);

            }
        
        
    getAll(showSpinner = true): Promise<OM.LocalizedEntity[]> {
                return CommonServices.get<OM.LocalizedEntity[]>(baseUrl + 'api/Localization/GetAll',{  }, showSpinner);

            }
        
        
    getEnabledLanguages(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/Localization/GetEnabledLanguages',{  }, showSpinner);

            }
        
        
    getSupportedLanguages(showSpinner = true): Promise<string[]> {
                return CommonServices.get<string[]>(baseUrl + 'api/Localization/GetSupportedLanguages',{  }, showSpinner);

            }
        
        
    editLocalizedValue(
        value:OM.LocalizedEntity,showSpinner = true): Promise<void> {
                return CommonServices.post<void>(baseUrl + 'api/Localization/EditLocalizedValue', value ,{}, showSpinner );

            }
                }

export let LocalizationClient = new _LocalizationClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}